<!--
 * @Author: wzh
 * @LastEditTime: 2024-11-07 14:14:28
 * @Description: 修改密码
-->
<template>
  <div class="update_password">
    <div class="container">
      <div class="title">{{ $t("base.password.update_password") }}</div>

      <div class="tips">
        <a-alert
          :message="`${alertMsg}${$t(
            'base.punctuation.bracket_left'
          )}${alertDesc}${$t('base.punctuation.bracket_right')}${$t(
            'base.punctuation.full_stop'
          )}`"
          type="warning"
          show-icon
        />
      </div>

      <UpdatePass
        ref="updatePassForm"
        :safeSetInfo="safeSetInfo"
        :pswSetInfo="pswSetInfo"
        :isHead="false"
        :isForget="false"
      />

      <div class="footer">
        <a-button @click="goLogin">{{ $t("base.btn.back_login") }}</a-button>
        <a-button type="primary" @click="handleOk">{{
          $t("base.btn.sure")
        }}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { commonAPI } from "@/apis";
import UpdatePass from "@/views/account/components/UpdatePass";
import { commonMethods } from "../mixins/common";
import { encryptAES } from "@/utils";

export default {
  name: "UpdatePassword",
  components: { UpdatePass },
  mixins: [commonMethods],
  data() {
    return {
      pswSetInfo: {},
      editPwd: null,
      alertMsg: "",
      alertDesc: "",
      before_login: {},
    };
  },
  beforeRouteEnter(to, form, next) {
    next((vm) => {
      // 判断是否可进入该路由
      let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
      if (!before_login || before_login.editPwd == "-1") {
        vm.$router.replace({ path: form.path });
      } else {
        vm.before_login = { ...before_login };
        let editPwd = before_login.editPwd;
        if (editPwd == 1) {
          vm.alertMsg = vm.$t("base.password.init_error");
        } else if (editPwd == 2) {
          vm.alertMsg = vm
            .$t("base.password.overtime_error")
            .replace("$xxx", vm.safeSetInfo.dqxgmmts);
        } else {
          vm.alertMsg = vm.$t("base.password.strength_error");
        }
      }
    });
  },
  created() {
    // 获取安全配置
    let safeSetInfo = sessionStorage.getItem("SAFE_SET_INFO");
    this.safeSetInfo = safeSetInfo ? JSON.parse(safeSetInfo) : {};

    this.getPswSet();
  },
  methods: {
    // 获取密码策略
    async getPswSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/pass/get"
      );
      if (code == 0) {
        this.pswSetInfo = { ...data };
        this.alertDesc = `${this.$t("base.password.update_alert")}${
          [
            "",
            this.$t("base.password.strength_weak"),
            this.$t("base.password.strength_medium"),
            this.$t("base.password.strength_strong"),
          ][this.pswSetInfo.bmz]
        }`;
      } else {
        this.$message.error(message);
      }
    },
    handleOk() {
      this.$refs.updatePassForm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          debugger;
          let form = this.$refs.updatePassForm.form;
          if (form.passwordStrength < this.pswSetInfo.bmz) {
            this.$message.warning(this.$t("base.password.update_error"));
            return;
          }

          let params = {
            username: this.user.username,
            ...form,
            firstPassword: "0",
          };
          params.confirmPassword = encryptAES(params.confirmPassword);
          params.oldPassword = encryptAES(params.oldPassword);
          params.password = encryptAES(params.password);
          this.handleOkApi(params);
        } else {
          return false;
        }
      });
    },
    async handleOkApi(params) {
      const { code, message } = await commonAPI.postAction(
        "/config/changePassword",
        params
      );
      if (code == 0) {
        this.$message.success(message);
        this.goLogin();
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.update_password::v-deep {
  width: 100%;
  height: 100%;
  padding-top: 35px;
  .container {
    max-width: 800px;
    width: 80%;
    margin: 0 auto;
    background-color: #fff;
    padding: 30px 0;
    border-radius: 20px;
    .title {
      font-size: 22px;
      text-align: center;
      margin-bottom: 20px;
    }

    .tips {
      padding: 0 35px;
      margin-bottom: 30px;
    }

    .footer {
      text-align: center;
      margin-top: 10px;
      .ant-btn + .ant-btn {
        margin-left: 40px;
      }
    }
  }
}
</style>
